import React, { Fragment } from "react";

import { useGranite } from "@redux/modules/value/translations/translations.provider";

import { ProductLabel } from "@components/Product/Layout/ProductLabel/productLabel.component";

type Props = {
    show: boolean;
};

const WebOnly = ({ show }: Props) => {
    const { t } = useGranite();

    if (!show) {
        return null;
    }
    return (
        <Fragment>
            <React.Fragment>
                <div className="row mb-2">
                    <ProductLabel text={t("pricing.webOnly")} />
                </div>
            </React.Fragment>
        </Fragment>
    );
};

export default WebOnly;
